// src/components/TreatmentList.js
import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

// Reusable components
import CustomNavbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const treatments = [
  { 
    title: "Acne & Scar Treatment", 
    desc: "Advanced solutions for clear, healthy skin.", 
    link: "/treatments/acne" 
  },
  { 
    title: "Tattoo Removal", 
    desc: "Safe and effective laser tattoo removal sessions.", 
    link: "/treatments/tattoo" 
  },
  { 
    title: "Hair Treatment", 
    desc: "Comprehensive hair restoration and scalp rejuvenation.", 
    link: "/treatments/hair" 
  },
  { 
    title: "Carbon Laser Facial", 
    desc: "Deep cleansing facial for instant glow and rejuvenation.", 
    link: "/treatments/carbonlaser" 
  },
  { 
    title: "Anti-Aging", 
    desc: "Wrinkle reduction and advanced skin tightening treatments.", 
    link: "/treatments/antiaging" 
  },
  { 
    title: "Laser Hair Removal", 
    desc: "Permanent hair reduction with advanced painless laser technology.", 
    link: "/treatments/laserhair" 
  },
  { 
    title: "Fungal Infection Treatment", 
    desc: "Effective solutions for skin and scalp fungal infections.", 
    link: "/treatments/fungalinfection" 
  },
  { 
    title: "Eczema & Psoriasis Care", 
    desc: "Long-term relief from chronic skin inflammation and irritation.", 
    link: "/treatments/eczema-psoriasis" 
  },
  { 
    title: "Nail Diseases & Treatment", 
    desc: "Expert care for nail infections and related conditions.", 
    link: "/treatments/nail-disease" 
  },
  { 
    title: "Chemical Peeling", 
    desc: "Skin renewal with customized chemical peel sessions.", 
    link: "/treatments/chemicalpeel" 
  },
  { 
    title: "Platelet Rich Plasma (PRP)", 
    desc: "Natural rejuvenation using your own plasma for skin and hair.", 
    link: "/treatments/prp" 
  },
  { 
    title: "Microneedling", 
    desc: "Boost collagen and reduce scars for smoother skin texture.", 
    link: "/treatments/microneedling" 
  },
  { 
    title: "Skin Glow Treatments", 
    desc: "Brightening therapies for radiant and even-toned skin.", 
    link: "/treatments/skinglow" 
  },
  { 
    title: "Skin Tag, Birthmark, Mole & Wart Removal", 
    desc: "Safe removal of skin tags, moles, warts, and birthmarks.", 
    link: "/treatments/skintag-removal" 
  },
];


const TreatmentList = () => {
  return (
    <>
      {/* Navbar */}
      <CustomNavbar />

      {/* Treatments Section */}
      <section className="py-5">
        <Container>
          <h2 className="fw-bold text-center mb-5">Our Treatments</h2>
          <Row>
            {treatments.map((t, i) => (
              <Col md={4} sm={6} className="mb-4" key={i}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title>{t.title}</Card.Title>
                    <Card.Text>{t.desc}</Card.Text>
                    <Link to={t.link}>
                      <Button variant="primary">View Details</Button>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default TreatmentList;
